import { biaIpTypeOptions, currencyOptions } from "@/common/const";
import {
  includedOptions,
  wiaAccessTechOptions,
} from "@/common/const/filter-options";
import { wiaInterfaceType } from "@/common/const/filter-options/wiaInterfaceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const wiaFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Country",
    name: "country",
    required: true,
  },
  {
    inputType: "select",
    label: "CPE",
    name: "CPE",
    required: true,
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },

  {
    inputType: "text",
    label: "Last Mile Provider",
    name: "lastMileProvider",
    required: true,
  },
  {
    inputType: "text",
    label: "Vendor Product Name",
    name: "vendorProductName",
    required: true,
  },
  {
    inputType: "text",
    label: "Download Speed (in Mbps)",
    name: "downloadSpeed",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "text",
    label: "Upload Speed (in Mbps)",
    name: "uploadSpeed",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Data Limit Type",
    name: "dataLimitType",
    required: true,
    options: [
      {
        label: "Capped",
        value: "capped",
      },
      {
        label: "Unlimited",
        value: "unlimited",
      },
    ],
  },
  {
    inputType: "text",
    label: "Data Limit (in GB)*",
    name: "dataLimitGB",
    required: true,
  },

  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },
  {
    label: "Currency",
    name: "currency",
    readonly: false,
    required: false,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "text",
    label: "MRE",
    name: "MRE",
    required: true,
  },
  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: true,
  },
  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: true,
    options: wiaAccessTechOptions,
  },
  {
    inputType: "select",
    label: "Interface/Handoff Type",
    name: "interface",
    required: true,
    options: wiaInterfaceType,
  },
  {
    inputType: "select",
    label: "IP",
    name: "IP",
    required: true,
    options: biaIpTypeOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    inputType: "text",
    label: "SLA Uptime (in %)",
    name: "SlaUptime",
    required: true,
  },
  {
    inputType: "text",
    label: "SLA MTTR (in Hours)",
    name: "SlaMTTR",
    required: true,
  },
  {
    label: "Price code",
    name: "priceCode",
    required: false,
    inputType: "text",
  },
];
export default wiaFormStrategy;
